// extracted by mini-css-extract-plugin
export var content = "content-module--content--VMrOY";
export var contentWithLink = "content-module--contentWithLink--ALknU";
export var contentLink = "content-module--contentLink--kLvqf";
export var sibling = "content-module--sibling--VmTWK";
export var heading = "content-module--heading--al12T";
export var extraPaddingTop = "content-module--extraPaddingTop--3P92d";
export var extraPaddingBottom = "content-module--extraPaddingBottom--YDIIH";
export var opaque = "content-module--opaque--OAbW2";